import { z } from 'zod';
import { ADVANCED_AUTONOMY_CAPABILITIES, AUTONOMY_CAPABILITIES } from './types';

export const autonomyPermissionSchema = z.enum([
  'manual_only',
  'approval_required',
  'autonomous_allowed',
]);

export const autonomyCapabilityRulesSchema = z.object(
  Object.fromEntries(
    AUTONOMY_CAPABILITIES.map((capability) => [capability, autonomyPermissionSchema]),
  ) as Record<(typeof AUTONOMY_CAPABILITIES)[number], typeof autonomyPermissionSchema>,
).strict();

export const autonomyPolicySchema = z.object({
  id: z.string().min(1),
  publicationId: z.string().min(1),
  versionNumber: z.number().int().positive(),
  capabilityRules: autonomyCapabilityRulesSchema,
  createdBy: z.string().nullable(),
  origin: z.string().min(1),
  createdAt: z.string().min(1),
  updatedAt: z.string().min(1),
});

export const advancedAutonomyLevelSchema=z.enum(['prohibited','human_required','autonomous_allowed']);
export const advancedAutonomyCapabilitySchema=z.enum(ADVANCED_AUTONOMY_CAPABILITIES);
export const autonomyConditionsSchema=z.object({resourceType:z.string().optional(),resourceId:z.string().optional(),platform:z.string().optional(),contentType:z.string().optional(),campaignOrigin:z.string().optional(),safetyState:z.string().optional(),minimumConfidence:z.enum(['low','medium','high']).optional(),currentnessState:z.string().optional(),sourceSensitivity:z.string().optional(),topic:z.string().optional(),campaignPriority:z.string().optional(),minimumPerformanceConfidence:z.enum(['low','medium','high']).optional(),resurfacingStatus:z.string().optional(),maximumAiCredits:z.number().nonnegative().optional(),outputFormat:z.string().optional(),destinationId:z.string().optional(),startTimeUtc:z.string().optional(),endTimeUtc:z.string().optional(),humanLocked:z.boolean().optional()}).strict();
export const advancedAutonomyRuleInputSchema=z.object({capability:advancedAutonomyCapabilitySchema,level:advancedAutonomyLevelSchema,priority:z.number().int().min(0).max(1000).default(0),conditions:autonomyConditionsSchema.default({}),effectiveFrom:z.string().nullable().optional(),expiresAt:z.string().nullable().optional()});

const identityContextSchema = z.object({
  id: z.string().min(1),
  sourceVersionId: z.string().min(1),
  analysisBundleId: z.string().min(1),
});

export const distributionAssessmentIdentitySchema = identityContextSchema;
export const temporalAssessmentIdentitySchema = identityContextSchema;

export const campaignStrategyVersionIdentitySchema = z.object({
  id: z.string().min(1),
  campaignId: z.string().min(1),
  versionNumber: z.number().int().positive(),
  sourceVersionId: z.string().min(1),
  analysisBundleId: z.string().min(1),
});

export const campaignAngleIdentitySchema = z.object({
  id: z.string().min(1),
  campaignId: z.string().min(1),
  campaignStrategyVersionId: z.string().min(1),
});

export const socialOutputIdentitySchema = z.object({
  id: z.string().min(1),
  campaignId: z.string().min(1),
  campaignAngleId: z.string().min(1),
  platformAccountId: z.string().min(1),
  platform: z.string().min(1),
});

export const socialOutputVersionIdentitySchema = z.object({
  id: z.string().min(1),
  socialOutputId: z.string().min(1),
  versionNumber: z.number().int().positive(),
});
